import { AppBar, Toolbar, Box, Button } from '@mui/material';
import { NavLink as RouterLink } from 'react-router-dom';
import HeaderUserbox from 'src/layouts/SidebarLayout/Header/Userbox';
import { LocalSeoIconSx, onBoardingNavbarSx } from './CommomSxs';
import { RootState } from 'src/redux/store';
import { useSelector } from 'react-redux';
import { getCookie, localStorageMethod } from './config/FunctionHelper';
import {
  localSeoLogo,
  localseoSignup,
  localSeoSignupSource,
  localSeoSignupSourceSqsp,
  localseoSignupSqspFlow
} from './config/TextMessage';

const OnBoardingNavbar = ({ openIntercom = true }) => {
  let activePlanName = useSelector((state: RootState) => state.user.activePlan);
  let planDetails = useSelector((state: RootState) => state.user.planDetails);
  const isFreePlan = activePlanName === planDetails?.free;
  const getLocalSeoCookie = getCookie(localseoSignup) ?? null;
  const getLocalSeoSqspCookie = getCookie(localseoSignupSqspFlow) ?? null;
  let userDetails: any =
    useSelector((state: RootState) => state.counter.userDetails) ?? {};
  const isLocalSeo =
    getLocalSeoCookie === localSeoSignupSource ||
    getLocalSeoSqspCookie === localSeoSignupSourceSqsp ||
    (!!userDetails?.isLocalSeo && activePlanName !== planDetails?.localseo);

  return (
    <AppBar
      position="fixed"
      sx={{
        boxShadow: '0px 4px 6px -1px rgba(0, 0, 0, 0.1)'
      }}
    >
      <Toolbar sx={onBoardingNavbarSx?.toolbar}>
        {/* Left side image */}
        <Box>
          <Button
            disableRipple
            disableElevation
            disableFocusRipple
            disableTouchRipple
            component={RouterLink}
            to={isFreePlan ? '/external-scans' : '/dashboard'}
            sx={onBoardingNavbarSx?.imgBtnSx}
            onClick={() => {
              // Remove items from localStorage
              localStorageMethod('remove', 'squareSpaceSite');
              localStorageMethod('remove', 'squareSpaceSiteId');
              localStorageMethod('remove', 'squareSpaceAccountId');
            }}
          >
            <img
              src={
                isLocalSeo ? localSeoLogo : '/static/images/logo/new-logo.svg'
              }
              alt="SEOSpace"
              style={isLocalSeo ? LocalSeoIconSx : {}}
            />
          </Button>
        </Box>

        {/* Spacer to push the right side items to the right */}
        <Box sx={onBoardingNavbarSx?.spacerBox} />

        {/* Right side items */}
        <Box sx={onBoardingNavbarSx?.rightSideBoxSx}>
          <HeaderUserbox openIntercom={openIntercom} />
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default OnBoardingNavbar;
